import React, {Component} from 'react';
import styles from './styles.css';

export default class FieldGroup extends Component {
	render() {
		let className = styles['bsui-field-group'];

		if (this.props.slim)
		{
			className += ' ' + styles['bsui-field-group_slim'];
		}

		if (this.props.className)
		{
			className += ' ' + this.props.className;
		}

		return (
			<ul className={className}>
				{React.Children.toArray(this.props.children).map(
					(item, key) => (
						<li key={key} className={styles['bsui-field-group__item']}>
							{item}
						</li>)
				)}
			</ul>
		);
	}
}